<template>
  <el-checkbox-group v-model="checkedList" @change="handleCheckedListChange">
    <div class="box" v-if="list.length > 0">
      <div class="item" v-for="item in list" :key="item.mate_id">
        <div slot="reference" class="music-box">
          <img :src="item.image_url" alt="" />
          <el-checkbox
            v-show="item.status === 2 && judgeArtType(item.redirect)"
            class="checkbox"
            :label="item"
            @change="handleCheck(item)"
          >
            <span></span>
          </el-checkbox>
          <p v-show="item.status !== 2" class="cover">{{ statusString[item.status] }}</p>
          <p v-show="item.status === 2 && !judgeArtType(item.redirect)" class="cover">不可选择</p>
        </div>
        <div class="img-name">{{ item.title }}</div>
      </div>
    </div>
    <div class="no-data" v-else>暂无数据</div>
  </el-checkbox-group>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    check: {
      type: Array,
      default() {
        return [];
      },
    },
    checkedChange: {
      type: Function,
      default() {
        return () => {};
      },
    },
    channel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checkedList: [], // checkboxGroup绑定的选择
      checkList: [], // 选择真正保存的地方
      statusString: ['待发布', '下线', '上线'],
    };
  },
  computed: {
    checkIds() {
      return this.checkList.map((item) => {
        return item.banner_id;
      });
    },
  },
  watch: {
    list: {
      handler(val) {
        this.checkedList = [];
        try {
          this.checkList = JSON.parse(JSON.stringify(this.checkList));
        } catch (err) {
          console.log(err);
        }
        for (const item of val) {
          if (this.checkIds.includes(item.banner_id)) {
            this.checkedList.push(item);
          }
        }
      },
    },
  },
  created() {
    try {
      this.checkList = JSON.parse(JSON.stringify(this.check));
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    findIndex(id) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].banner_id === id) {
          return i;
        }
      }
      return -1;
    },
    handleCheck(item) {
      if (this.checkedList.includes(item)) {
        console.log('增加运营位');
        if (this.checkIds.length === 4) {
          this.$message.warning('添加的运营位数量不能超过4个');
          this.checkedList.splice(this.checkedList.length - 1, 1);
          return;
        }
        if (!this.checkIds.includes(item.banner_id)) {
          this.checkList.push(item);
        }
      } else {
        console.log('删除运营位');
        if (this.checkIds.includes(item.banner_id)) {
          this.checkList.splice(this.findIndex(item.banner_id), 1);
        }
      }
      this.$emit('checkedChange', this.checkList);
    },
    handleCheckedListChange() {},
    judgeArtType(artId) {
      // 对空字符串不做判断
      if (artId.length === 0) {
        return true;
      }
      // // 对外链不做判断
      // if (artId.indexOf('http') !== -1) {
      //   return true;
      // }
      // console.log(artId);
      // 计算id来源是否和文章列表的channel相匹配：企业微信文章id（纯数字），公众号微信文章id
      const r = /^\d+$/;
      if (r.test(artId)) {
        if (this.channel === '企业微信') {
          return true;
        }
      } else if (this.channel === '公众号') {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-wrap: wrap;
}
.item {
  position: relative;
  margin: 0 10px;
  width: 240px;
  height: 138px;
  img {
    width: 240px;
    height: 102px;
  }
  .checkbox {
    position: absolute;
    top: 7px;
    right: -2px;
    z-index: 55;
  }
  .img-name {
    height: 36px;
    font-size: 14px;
    width: 240px;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 36px;
    color: #303133;
    overflow: hidden;
  }
}
.no-data {
  height: 50px;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
}
.cover {
  width: 100%;
  height: 102px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 18px;
}
</style>
